import {Badge} from '@mantine/core';

import {SubscriptionStatus} from '../types';

/**
 * FNP-918: subscription status as a badge (checklist §13).
 *
 * ⚠️ Colours were hardcoded HEX (`#dc3545`, `#28a745`, …) — Bootstrap's palette,
 * not Mantine's, which violates §2 "no hardcoded colours". Hex values do not
 * respond to the theme, so every one of these rendered the same in dark mode as
 * in light, and none of them matched the surrounding chrome. They are Mantine
 * theme colour NAMES now, so the badge picks up the right shade per scheme.
 *
 * The status text is always rendered, so colour is never the sole carrier of
 * meaning (§13 accessibility).
 */
const STATUS_COLORS: Record<string, string> = {
    [SubscriptionStatus.incomplete]: 'blue',
    [SubscriptionStatus.incomplete_expired]: 'gray',
    [SubscriptionStatus.trialing]: 'yellow',
    [SubscriptionStatus.past_due]: 'red',
    [SubscriptionStatus.canceled]: 'gray',
    [SubscriptionStatus.unpaid]: 'yellow',
    [SubscriptionStatus.active]: 'green',
    [SubscriptionStatus.paused]: 'gray',
};

export const StatusBadge = ({status}: {status: string}) => (
    // An unrecognised status still renders — as a neutral badge rather than a
    // colourless one, so a new Stripe status is visible instead of invisible.
    <Badge color={STATUS_COLORS[status] ?? 'gray'}>{status}</Badge>
);
